import React, { useEffect, useState } from 'react';

const YearPicker = ({ onChange, onYearClick, selectedYear, isMonthYearPicker }) => {
    const [years, setYears] = useState([]);

    const [startYear, setStartYear] = useState('');

    useEffect(() => {
        setStartYear(selectedYear - Math.ceil(selectedYear % 12));
    },[])

    useEffect(() => {
        generateYears(startYear);
    },[startYear])

    const generateYears = (startYear) => {
        if(startYear < 0){
            return;
        }
        const years = [];
        for (let i = startYear; i <= startYear + 11 ; i++) {
            years.push(i);
        }
        setYears(years);
    };

    const clickHandler = (e) => {
        if(isMonthYearPicker){
            onChange();
        }
        onYearClick(e);
    }

    const handleLeftArrow = () => {
        if(startYear <= 0){
            return
        }
        setStartYear(prevState => prevState - 12)
    }

    return (
        <div className="year-picker">
            <div className='flex justify-between px-3 mb-[36px]'>
                <img src='assets/images/calendar-arrow-left.svg'
                    data-testid='prev-year' onClick={handleLeftArrow} loading='lazy'/>
                <div className='text-primary'>{`${years[0]} - ${years[11]}`}</div>
                <img src='assets/images/calendar-arrow-right.svg' 
                    onClick={() => setStartYear(prevState => prevState + 12)}
                    data-testid='next-year'
                    loading='lazy'
                />
            </div>
            <div className='grid grid-cols-4 grid-rows-3 gap-5 w-[290px]'>
                {years.map((year) => (
                    <div 
                        data-testid={year}
                        key={year} 
                        value={year} 
                        onClick={clickHandler}
                        className={`grid-item flex justify-center items-center p-2 cursor-pointer 
                                ${selectedYear === year ? 'text-primary' : 'text-[#1f1f1f]'}`}>
                        {year}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default YearPicker;